const viewTypeConstants = {
  BUYING: 'buying',
  SELLING: 'selling',
};

export default viewTypeConstants;
